import { Component, OnInit } from '@angular/core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { ParamService } from '../../shared/services/param.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-search-survey',
    templateUrl: './search-survey.component.html',
    styleUrls: ['./search-survey.component.scss']
,  standalone: false
})
export class SearchSurveyComponent {
    faSearch = faSearch;
  constructor(private paramservice: ParamService, private router: Router) { }

    
    search(searchText: string) {//debugger
      
      this.paramservice.Parameterpass(searchText);
      
    }

}
